import Vue from "vue";
import vSelect from "vue-select";

Vue.component("v-select", vSelect);

const app = new Vue({
    el: "#search-app",
    data: {
        message: "Hello Vue!",
        baseItems: [],
        items: [],
        countries: [],
        countriesFiltered: [],
        country: null,
        cities: [],
        citiesFiltered: [],
        city: null,
        departments: [],
        departmentsFiltered: [],
        department: null,

        loaded: false,

        // pagination vars
        showPagination: false,
        currentPage: 1,
        totalPages: 1,
        perPage: 10,
        indexOfLastOffer: 1,
        indexOfFirstOffer: 1,
        currentItems: [],
        showPages: [],
    },
    mounted() {
        this.loadData();

        window.addEventListener('popstate', event => {
            this.loadSettingsFromUrl();
            this.filterItems();
            this.reloadPagination();
        });
    },
    watch: {
        country: function(newVal, oldVal) {
            if(newVal !== oldVal) {
                this.filter();
            }
        },
        department: function(newVal, oldVal) {
            if(newVal !== oldVal) {
                this.filter();
            }
        },
        city: function(newVal, oldVal) {
            if(newVal !== oldVal) {
                this.filter();
            }
        },
    },
    methods: {
        loadData: function() {
            fetch('data.json')
                .then(response => response.json())
                .then(data => {
                    this.baseItems = data;
                    this.items = data;

                    this.countries = data.map(item => item.country).filter((value, index, self) => self.indexOf(value) === index);
                    this.departments = data.map(item => item.department).filter((value, index, self) => self.indexOf(value) === index);
                    this.cities = data.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);

                    this.countriesFiltered = this.countries;
                    this.departmentsFiltered = this.departments;
                    this.citiesFiltered = this.cities;

                    this.loadSettingsFromUrl();
                    this.filterItems()

                    this.reloadPagination();

                    this.loaded = true;
                }
            );
        },
        reset: function() {
            this.department = null;
            this.city = null;
            this.country = null;

            this.citiesFiltered = this.cities;
            this.departmentsFiltered = this.departments;
            this.countriesFiltered = this.countries;

            this.currentPage = 1;

            this.clearUrl();
            this.filterItems();
            this.reloadPagination();
        },
        search: function() {
            this.currentPage = 1;
            this.filterItems();
            this.reloadPagination();
            this.saveUrl();
        },
        filter: function() {
          const items = this.baseItems;
          this.citiesFiltered = this.cities;
          this.departmentsFiltered = this.departments;
          this.countriesFiltered = this.countries;

          if (this.country){
              this.citiesFiltered = items.filter(item => item.country === this.country).map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
              this.departmentsFiltered = items.filter(item => item.country === this.country).map(item => item.department).filter((value, index, self) => self.indexOf(value) === index);
          }

          if(this.city) {
               this.departmentsFiltered = items.filter(item => item.city === this.city).map(item => item.department).filter((value, index, self) => self.indexOf(value) === index);
               this.countriesFiltered = items.filter(item => item.city === this.city).map(item => item.country).filter((value, index, self) => self.indexOf(value) === index);
          }

          if(this.department){
              this.countriesFiltered = items.filter(item => item.department === this.department).map(item => item.country).filter((value, index, self) => self.indexOf(value) === index);
              this.citiesFiltered = items.filter(item => item.department === this.department).map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
          }


        },
        filterItems: function() {
            this.items = this.baseItems.filter(item => {
                let country = this.country ? item.country === this.country : true;
                let department = this.department ? item.department === this.department : true;
                let city = this.city ? item.city === this.city : true;

                return country && department && city;
            });
        },
        reloadPagination: function() {
            this.currentItems = [];

            this.totalPages = Math.ceil(this.items.length / this.perPage);
            this.indexOfLastOffer = this.currentPage * this.perPage;
            this.indexOfFirstOffer = this.indexOfLastOffer - this.perPage;
            this.currentItems = this.items.slice(this.indexOfFirstOffer, this.indexOfLastOffer);

            if (this.totalPages < 6) {
                this.showPages = this.range(1, this.totalPages);
            } else if (this.currentPage - 2 > 0 && this.currentPage + 2 < this.totalPages) {
                this.showPages = this.range(this.currentPage - 2, this.currentPage + 2);
            } else if (this.currentPage - 1 > 0 && this.currentPage + 3 < this.totalPages) {
                this.showPages = this.range(this.currentPage - 1, this.currentPage + 3);
            }
            else if (this.currentPage - 1 < 1) {
                this.showPages = this.range(1, 5);
            } else {
                this.showPages = this.range(this.totalPages - 4, this.totalPages);
            }


            this.showPagination = this.items.length > this.perPage;
        },
        range: function (from, to) {
            let arr = [];
            for(let i = from; i <= to; ++i) {
                arr.push(i);
            }
            return arr;
        },
        setCurrentPage: function(page) {
            this.currentPage = page;
            this.saveUrl();
            this.reloadPagination();
            window.runScroll('#search-app');
        },
        nextPage: function() {
            if(this.currentPage < this.totalPages) {
                this.setCurrentPage(this.currentPage + 1);
                this.saveUrl();
            }
        },
        prevPage: function() {
            if(this.currentPage > 1) {
                this.setCurrentPage(this.currentPage - 1);
                this.saveUrl();
            }
        },
        saveUrl: function() {
            let url = new URL(window.location.href);
            url.searchParams.delete('page');
            url.searchParams.delete('city');
            url.searchParams.delete('country');
            url.searchParams.delete('department');

            if(this.country) {
                url.searchParams.set('country', this.country);
            }
            if(this.city) {
                url.searchParams.set('city', this.city);
            }
            if(this.department) {
                url.searchParams.set('department', this.department);
            }
            if(this.currentPage > 1) {
                url.searchParams.set('page', this.currentPage);
            }

            window.history.pushState({}, '', url);
        },
        loadSettingsFromUrl() {
            let url = new URL(window.location.href);
            let page = url.searchParams.get('page');
            let city = url.searchParams.get('city');
            let country = url.searchParams.get('country');
            let department = url.searchParams.get('department');

            if(page) {
                page = parseInt(page);
                if(page > 0 ) {
                    this.currentPage = parseInt(page);
                    setTimeout(() => {
                        if(this.currentPage > this.totalPages) {
                            this.currentPage = this.totalPages;
                            this.saveUrl();
                            this.reloadPagination();
                        }
                    });
                }
            } else {
                this.currentPage = 1;
            }
            if(city) {
                if(this.cities.includes(city))
                    this.city = city;
                else {
                    url.searchParams.delete('city');
                    window.history.pushState({}, '', url);
                }
            } else {
                this.city = null;
            }
            if(country) {
                if(this.countries.includes(country))
                    this.country = country;
                else  {
                    url.searchParams.delete('country');
                    window.history.pushState({}, '', url);
                }
            } else {
                this.country = null;
            }
            if(department) {
                if(this.departments.includes(department))
                    this.department = department;
                else {
                    url.searchParams.delete('department');
                    window.history.pushState({}, '', url);
                }
            } else{
                this.department = null;
            }
        },
        clearUrl() {
            let url = new URL(window.location.href);
            url.searchParams.delete('page');
            url.searchParams.delete('city');
            url.searchParams.delete('country');
            url.searchParams.delete('department');
            window.history.pushState({}, '', url);
        }
    }
});
